module.exports = __webpack_public_path__ + "img/horse.cc2b7a02.png";